"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "STable", {
  enumerable: true,
  get: function get() {
    return _STable.default;
  }
});
var _STable = _interopRequireDefault(require("./STable"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }